var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"e-flex e-justify-center e-items-center"},[_c('SummaryElement',{attrs:{"read-only":"","label":_vm.formattedTitles[_vm.title] || _vm.title}},[_c('ScoreBar',{staticClass:"kit-metric__gauge-chart",attrs:{"score":_vm.value,"max-score":_vm.computedMax,"invert-colors":"","suffix":_vm.suffix}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }